import {gsap} from "../../../../libs/gsap/all.js"
import 'pixi.js/math-extras';
import {AnimatedSprite} from "./AnimatedSprite";

// Constructor
export class FadeUpSprite extends AnimatedSprite {

  constructor(x, y, asset, appearingScreenPercent, game) {
    super(x, y, asset, appearingScreenPercent, game);
  }

  buildAnimations() {
    // Move the anchor point for this type of animation and offset the position
    this.sprite.anchor.set(0.5, 1);
    this.position.x = this.pos.x + this.sprite.width / 2;
    this.position.y = this.pos.y + this.sprite.height;

    this.inAnimation = gsap.fromTo(this.sprite,
      {
        pixi: {
          y: 40,
          alpha: 0,
        },
      },
      {
        pixi: {
          y: 0,
          alpha: 1,
        },
        ease: "back.out(1.7)",
        immediateRender: true, // scale 0 immediately, even if tween is paused
        paused: true,
        duration: 1,
      }
    )
  }
}
